module.exports = __webpack_public_path__ + "static/media/barChart-fullscreen.f23e0eec.png";